import { render, staticRenderFns } from "./FormResponsesTable.vue?vue&type=template&id=ea1da204&scoped=true"
import script from "./FormResponsesTable.vue?vue&type=script&lang=js"
export * from "./FormResponsesTable.vue?vue&type=script&lang=js"
import style0 from "./FormResponsesTable.vue?vue&type=style&index=0&id=ea1da204&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1da204",
  null
  
)

export default component.exports